@if (loader) {
  <ng-container *ngTemplateOutlet="kpiBarSkeleton"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="kpiBarContent"></ng-container>
}

<ng-template #kpiBarContent>
  <!-- For Services section the order of metric total and kpi container need to be swapped, using flex-row-reverse allows us to do it without defining multiple conditional blocks -->
  <div 
    class="kpi-bar-container flex gap-6 items-center justify-between" id="{{ kpiName }}" 
    [class.flex-row-reverse]="serviceType === ServiceMetricTypes.Services"
  >
    <section class="metric-total-container px-4 py-2 flex gap-6 border-solid border-1 border-neptune-color-primary-200 rounded">
      <div class="metric-data flex flex-col">
        <span class="metric-value text-2xl font-bold">{{metricTotal | number: "1.0-0" }}</span>
        <span class="metric-units text-base text-neptune-color-fg-muted">{{metricTotalDisplayUnits }}</span>
      </div>
      @if (serviceType == ServiceMetricTypes.Services) {
        <div class="checkbox-container flex gap-2 items-center">
          <input
            class="metric-checkbox w-4 h-4 accent-blue"
            #addMetricTotal
            type="checkbox"
            [checked]="metricTotalChecked"
            (click)="$event.stopPropagation()"
            (change)="_onMetricTotalCheckedChange(addMetricTotal.checked)"
          />
          Add
        </div>
      }
    </section>
    <section class="kpi-container px-4 py-2 flex gap-6 border-solid border-1 border-neptune-color-primary-200 rounded">
      <div class="kpi-data flex flex-col">
        <span class="kpi-value text-2xl font-bold">
          {{kpiTotal | number: "1.0-0" }}@if (kpiName == 'CallsByReason') {%}
        </span>
        <span class="kpi-units text-base text-neptune-color-fg-muted">{{displayKpiUnits }}</span>
      </div>
      @if (kpiName != 'CallsByReason') {
        <div class="checkbox-container flex gap-2 items-center">
          <input
            class="kpi-checkbox w-4 h-4 accent-blue"
            #addKpi
            type="checkbox"
            [checked]="kpiChecked"
            (click)="$event.stopPropagation()"
            (change)="_onKpiCheckedChange(addKpi.checked)"
          />
          Add
        </div>
      }
    </section>
  </div>
</ng-template>

<ng-template #kpiBarSkeleton>
  <div
    id="{{ kpiName }}-skeleton"
    class="kpi-bar-container flex gap-6 items-center justify-between animate-pulse"
  >
    <!-- metric total panel skeleton -->
    <div class="px-4 py-2 flex gap-6 border-solid border-1 border-neptune-subtle rounded">
      <div class="flex flex-col gap-1">
        <div class="h-8 w-16 bg-neptune-subtle rounded"></div>
        <div class="h-4 w-24 bg-neptune-subtle rounded mt-1"></div>
      </div>
      <div class="flex gap-2 items-center">
        <div class="h-4 w-4 bg-neptune-subtle rounded"></div>
        <div class="h-4 w-6 bg-neptune-subtle rounded"></div>
      </div>
    </div>

    <!-- KPI panel skeleton -->
    <div class="px-4 py-2 flex gap-6 border-solid border-1 border-neptune-subtle rounded">
      <div class="flex flex-col gap-1">
        <div class="h-8 w-16 bg-neptune-subtle rounded"></div>
        <div class="h-4 w-24 bg-neptune-subtle rounded mt-1"></div>
      </div>
      <div class="flex gap-2 items-center">
        <div class="h-4 w-4 bg-neptune-subtle rounded"></div>
        <div class="h-4 w-6 bg-neptune-subtle rounded"></div>
      </div>
    </div>
  </div>
</ng-template>
